import React, { useEffect, useState } from 'react';
import ServiceAccounts from 'components/SuperAdmin/ServiceAccounts';
import ContentLayout from 'components/Common/ContentLayout';
import GroupAPI from 'api/GroupAPI';
import { IKeycloakTeam } from './TeamAccess';
import { useSnackbar } from 'notistack';

const ServiceAccountAccess = () => {
  const [ serviceAccountGroups, setServiceAccountGroups ] = useState<IKeycloakTeam[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const datahubID = process.env.REACT_APP_DATAHUB_ID!;

  const getListOfGroupsAndFilter = () => {
    GroupAPI.getGroupsForAdmin().then((teamResp) => {
      if (teamResp?.success) {
        const filteredTeams = teamResp.result.filter((team: any) => team.name === 'Service Accounts');
        setServiceAccountGroups(filteredTeams[0].subGroups);
      }
    });
  };

  const removeDatahubAccess = async(teamId: string, teamName: string) => {
    const archivedTeamResp = await GroupAPI.removeRoleFromGroup(teamId, datahubID, 'datahub');
    if (archivedTeamResp?.success) {
      enqueueSnackbar(`Successfully removed access from ${teamName}`, { variant: 'success' });
      // refresh page so changes take place on UI
      history.go(0);
    } else{
      const err_text = `Error removing access from: ${archivedTeamResp?.result}`;
      enqueueSnackbar(err_text, { variant: 'error' });
    };
  };

  const addDatahubAccess = async(teamId: string, teamName: string) => {
    const activatedTeamResp = await GroupAPI.addRoleToGroup(teamId, datahubID, 'datahub');
    if (activatedTeamResp?.success) {
      enqueueSnackbar(`Successfully added access to ${teamName}`, { variant: 'success' });
      // refresh page so changes take place on UI
      history.go(0);
    } else{
      const err_text = `Error adding access to: ${activatedTeamResp?.result}`;
      enqueueSnackbar(err_text, { variant: 'error' });
    };
  };

  useEffect(() => {
    getListOfGroupsAndFilter();
  }, []);

  return (
    <ContentLayout title='List of Service Accounts in Bite 2.0'>
      <ServiceAccounts serviceAccountGroups={serviceAccountGroups} removeDatahubAccess={removeDatahubAccess} addDatahubAccess={addDatahubAccess} />
    </ContentLayout>
  );
};

export default ServiceAccountAccess;
